import React, { useEffect } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import { deleteSingleSaleOrd } from '../../../Store/PHPSlice/Sale/SaleOrder';
import { Button } from '@mui/material';

const TableBody = ({
    serialNumber,
    id,
    ordt,
    sono,
    quotNo,
    entry_type,
    firmNm,
    partyNm,
    grpNm,
    totQty,
    orderno,
    schoolNm,
    cltsts,
    userId,
    userNm,
    selected,
    barcode,
    handleClick,
}) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== window.location.origin) return;

            if (event.data === "REFRESH_PARENT") {
                window.location.reload();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/SaleOrderEdit/${sono}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const handleViewClick = () => {
        window.open(`/SOinfo/${sono}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleMaterialViewClick = () => {
        window.open(`/SOMaterialInfo/${sono}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Sale Order?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleSaleOrd(sono))
                .then((res) => {
                    // Reload the page to show updated results
                    toast.success("Sale Order Deleted");
                    window.location.reload();
                    // console.log(res);
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    const handleClothIssue = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/sowise-cloth-issue/${sono}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleMaterialViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DescriptionIcon />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {ordt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {entry_type === '0' ? 'QTWise' : 'Direct'}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>



                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {quotNo !== null ? quotNo : '-'}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totQty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {schoolNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button variant="contained" color="primary" size='small' disabled={cltsts === '1'} onClick={handleClothIssue}>Issue</Button>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${cltsts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${cltsts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>

                {userdata?.role === "1" &&
                    <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                        {userNm}
                    </TableCell>}

            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
